import React from 'react';
import * as S from './InfoBlock.styles';

import IconSelector from '@ibibo/icon-selector';
import useCarousel from '@ibibo/use-carousel';
import {defaultTheme} from '@ibibo/build-theme';

const data = [{
  id: 'item1',
  icon: 'property',
  title: 'WIDEST RANGE OF PROPERTIES',
  subTitle: '700k+ International properties | 77k+ Domestic properties'
}, {
  id: 'item2',
  icon: 'deal',
  title: 'BEST EVER RATES',
  subTitle: 'Preferential rates for our partners'
}, {
  id: 'item3',
  icon: 'onboardingmysafety',
  title: 'MYSAFETY ASSURANCE',
  subTitle: 'Safe and Hygienic stays with MySafety compliant properties'
}, {
  id: 'item4',
  icon: 'assure',
  title: 'CONFIDENTIALITY ASSURED',
  subTitle: 'Complete confidentiality of your customer details & bookings'
}, {
  id: 'item5',
  icon: 'customercare',
  title: 'EXPRESS CARE',
  subTitle: 'Easy-to-use tools for query resolutions'
}];

const styleProps = {
  width: '2rem',
  height: '2rem',
  fill: defaultTheme.colors.blue.base
}

const InfoStrip = () => {
  const {
    dataList,
    increment,
    decrement,
    isLeftCursorActive,
    isRightCursorActive,
  } = useCarousel(data, 4);

  return (
    <S.InfoStripWrapper>
      <S.InfoBlockInner>
        <S.MoreInfoList>
          {(isLeftCursorActive && <S.ArrowIconLeftWrapper  onClick={decrement}>
            <IconSelector iconKey="leftarrow" props={styleProps} />
          </S.ArrowIconLeftWrapper>) || null}
          {dataList.map(item => <li key={item.id}>
            <S.IconWrapper>
              <IconSelector iconKey={item.icon} />
            </S.IconWrapper>
            <S.InfoOuterWrap>
              <S.MoreInfoHeadText>{item.title}</S.MoreInfoHeadText>
              <S.MoreInfoSubText>{item.subTitle}</S.MoreInfoSubText>
            </S.InfoOuterWrap>
          </li>)}
          {(isRightCursorActive && <S.ArrowIconRightWrapper onClick={increment}>
            <IconSelector iconKey="rightarrow" props={styleProps} />
          </S.ArrowIconRightWrapper>) || null}
        </S.MoreInfoList>
      </S.InfoBlockInner>
    </S.InfoStripWrapper>
  );
};

export default InfoStrip;
